/**
 * Which admin orders count toward "sold" / Team Sales (after confirmation, not while pending).
 * Cancelled orders never count — if confirmed then cancelled, status is cancelled → excluded.
 */

export function normalizeBackendOrderStatus(order) {
  return String(order?.status ?? '')
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function isCancelledOrder(order) {
  const s = normalizeBackendOrderStatus(order);
  return s === 'cancelled' || s === 'canceled';
}

/** Post-confirmation pipeline (matches Orders.js / useUpdateOrderStatus backend slugs). */
const COUNTS_TOWARD_SOLD = new Set([
  'confirmed',
  'processing',
  'packed',
  'dispatched',
  'shipped',
  'in transit',
  'out for delivery',
  'delivered',
  'complete',
  'completed',
]);

/**
 * @returns {boolean} true if this order should contribute to sold units / revenue in Team Sales
 */
export function orderCountsTowardSoldSales(order) {
  if (!order || isCancelledOrder(order)) return false;
  const s = normalizeBackendOrderStatus(order);
  if (!s || s === 'pending') return false;
  return COUNTS_TOWARD_SOLD.has(s);
}
